export enum TableRowSize {
  large = 'large',
  small = 'small',
}
